export { default } from './StudentInfo';

